/**
 * External dependencies
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import ReloadAPP from '@naruto/naruto-components/src/page/v1/Reload';

/**
 * Internal dependencies
 */
import MainAPP from '@naruto/bgdcms/src/components/App';
import createProvider from '@naruto/bgdcms/src/providers';
import Env from '@naruto/bgdcms/src/env';
import Debug from '@naruto/naruto-models/src/core/debug';
import getDebugData from '@naruto/bgdcms/src/base/debug';
import getReduxConfigData from '@naruto/bgdcms/src/base/redux';
import { initializeLangConfig } from '@naruto/bgdcms/src/langs';
import '@naruto/bgdcms/src/css/index.css';
import '@naruto/bgdcms/src/plugin';
import 'react-quill-new/dist/quill.snow.css';

async function initializeProcessEnv(): Promise<boolean> {
  const success = await Env.initializeFromNginx();
  return success;
}

async function enableDebug(): Promise<void> {
  const DebugLog = new Debug();
  if (Env.config.Debug) DebugLog.printInConsole(getDebugData(Env));
}

async function renderMainApp(): Promise<void> {
  const { Provider, initialStore } = createProvider(getReduxConfigData(Env));
  const nonce = document.head.querySelector('[property~=csp-nonce][content]')?.getAttribute('content') as string;
  const cache = createCache({
    key: 'naruto-app-prefix',
    nonce,
    prepend: true
  });
  ReactDOM.render(
    <Provider store={initialStore}>
      <CacheProvider value={cache}>
        <MainAPP />
      </CacheProvider>
    </Provider>,
    document.getElementById('root')
  );
}

async function renderLoadFailedApp(): Promise<void> {
  ReactDOM.render(<ReloadAPP />, document.getElementById('root'));
}

async function main(): Promise<void> {
  /* 初始化環境變數 */
  const initializeSuccess = await initializeProcessEnv();
  /* 初始化 APP 語系設定檔 */
  initializeLangConfig();
  /* 渲染 APP */
  if (initializeSuccess) {
    await renderMainApp();
  } else {
    await renderLoadFailedApp();
  }
  /* 開關 DEBUG */
  await enableDebug();
}

main();
